import { MapDataAction } from 'src/app/model/map-actions/map_data-action';
import { IsSuppressing } from 'src/app/model/extra-params';
import { ButtonGroupService, ButtonSets } from './../../services/button-group.service';
import { ROICorners } from './../draw-pane/rectangle-roi';
import { point, destination, envelope, lineString } from '@turf/turf';
import { SpatialUnits } from './../../model/Pixospatial';
import { Component, OnInit, AfterContentInit, ElementRef, ViewChild, OnDestroy, EventEmitter, Input, Output, HostBinding, ChangeDetectorRef } from '@angular/core';
import { MapService } from 'src/app/services/map.service';


import { environment } from '../../../environments/environment';
import { LayersApiService } from 'src/app/model/api-services/layers-api.service';
import { LayerApiService } from 'src/app/model/api-services/layer-api.service';
import { SLMap } from 'src/app/model/sl-map';
import { ToolSetComponent } from '../tool-set/tool-set.component';
import { ToolService } from 'src/app/services/tool-service';
import { MapPosition } from 'src/app/types/mapposition';
import { ModalLocationEntryService } from '../dialogs/modal-location-entry/modal-location-entry.service';
import { InterruptableTimer } from 'src/app/model/interruptabletimer';
// import * as MobileDetect from 'mobile-detect';
import 'pepjs';
import { DynamicComponentService } from 'src/app/services/dynamic-component.service';
import { DictHandler, SimpleRecord } from 'src/app/types/@types/sl-v-types';
import { Decorable } from 'src/app/types/decorable';
import { DrawPaneComponent } from '../draw-pane/draw-pane.component';
import { PixoSpatial, PixoPt, SpatialCoord, PixoSpatialCoord } from 'src/app/model/Pixospatial';
import { SLLayer } from 'src/app/model/sl-layer';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { SpatialTooltip } from 'src/app/model/spatial-tooltip';
import { PUCManager } from '../p-u-c/p-u-c-manager';
import { EditorAction } from 'src/app/model/map-actions/editor-action';
// @ts-ignore
import mapboxgl from '!mapbox-gl';
import { NavEvents } from 'src/app/model/NavEvents';
import { NavigationAction } from 'src/app/model/map-actions/navigation-action';
import { LngLatBounds } from 'mapbox-gl';
import { StatefulCSS } from 'src/app/model/stateful_css';
import { ButtonService } from 'src/app/services/button.service';
import { ActionHandlerService } from 'src/app/services/action-handler.service';
import { AttributeViewComponent } from '../attribute-view/attribute-view.component';
import { InfoAction } from 'src/app/model/map-actions/info-action';
import { optimize } from 'webpack';
import { DisplayAction } from 'src/app/model/map-actions/display-actions';
import { MapTaskSequencer } from 'src/app/model/map-task-sequencer';
import { FeatureFilterService } from 'src/app/services/feature-filter.service';

export type MapInteractionMode = 'info' | 'querying' | 'queryingVis' |
  'tooltipping' | 'hovertipping' | 'singleSelecting' | 'singleDeselecting' |
  'roiQuerying' | 'roiQueryingVis' | 'roiSelecting' | 'roiUnselecting' | 'navigating' |
  'panning' | 'zooming' | 'digitizing';

export type MapInteractionModeOverride = 'overrideDigitizing' | 'overrideQuerying' | 'overrideQueryingVis' |
  'overrideRoiQuerying' | 'overrideRoiQueryingVis' | 'overrideNavigating' | 'overrideTooltipping' | 'overrideHoverTipping';

export type MapInteractionModes = SimpleRecord<MapInteractionMode | MapInteractionModeOverride, boolean>;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, AfterContentInit, OnDestroy {
  @HostBinding('class.reticle-enabled') reticleEnabled = false;
  @ViewChild('drawPane', { static: true }) drawPane: DrawPaneComponent;
  @ViewChild('mapContainer', { static: true }) mapContainer: ElementRef;
  @ViewChild('reticle', { static: true }) printReticle: ElementRef;

  public map: SLMap;
  public infoElement: JQuery<HTMLElement>;
  public isHolding = false;
  public lookup = {
    queryingVis: ['queryingVis', 'querying'],
    querying: ['querying', 'queryingVis'],
    roiQueryingVis: ['roiQueryingVis', 'roiQuerying'],
    roiQuerying: ['roiQuerying', 'roiQueryingVis']
  }
  public PUCMan: PUCManager;
  public spatialContext: PixoSpatial;

  public offsetTop: number;
  public offsetLeft: number;


  private initPosition: MapPosition;
  private mapBuilt: boolean;
  private style = 'mapbox://styles/mapbox/satellite-streets-v11';
  private toolSet: ToolSetComponent;

  private _digitizerOn = false;
  @Input('digitizerOn')
  set digitizerOn(newVal: boolean) {
    if (newVal === this.map.src.attributeView?.vertexTools?.isEditing) {
      if (this.drawPane.isOn === newVal) {
        if (newVal === false) {
          const attView = this.map.src.attributeView as AttributeViewComponent;
          attView?.HandleAdvUnset();
        }
        return;
      }
    }
    if (newVal === true) {
      this.drawPane.TurnOn();
    } else {
      this.drawPane.TurnOff(true);
    }
    this.SLMap.DigitizerUpdated();

  }
  public get digitizerOn(): boolean {
    if (!this.drawPane) return false;
    if (!this.drawPane.isOn) return false;
    if (['feature', 'snap'].indexOf(this.drawPane.drawMode) > -1) return true;
    if (this.drawPane.interactionMode === 'feature') return true;
    return false;
  }
  @Output()
  digitizerOnChange = new EventEmitter<boolean>();


  @Output()
  public interactions: EventEmitter<any> = new EventEmitter();
  @Output()
  public interactionsChanges: EventEmitter<any> = new EventEmitter();


  public get dynComponentSvc(): DynamicComponentService {
    return this.dynamicComponentService;
  }

  public get locationService(): ModalLocationEntryService {
    return this.modalLocService;
  }
  public get home(): MapPosition {
    return this.initPosition;
  }
  public get layerAPI(): LayerApiService {
    return this.layerService;
  }
  public get layersAPI(): LayersApiService {
    return this.layersService;
  }
  public get queryAllSearchableLayers(): boolean {
    return this._queryAll;
  }
  public get SLMap(): SLMap {
    return this.map;
  }
  public set queryAllSearchableLayers(tOrF: boolean) {
    this._queryAll = tOrF;

    let matched = false;
    for (const interaction in this.lookup) {
      if (this.lookup.hasOwnProperty(interaction)) {
        if (this.IsInteracting(interaction)) {
          matched = true;
          const val = this.lookup[interaction][this._queryAll ? 1 : 0];
          if (val !== interaction) {
            this.ToggleInteraction(val, true);
          }
          break;
        }
      }
    }
  }

  private _queryAll = true;
  private subscriptions: SubScriptionMgr = new SubScriptionMgr();

  private holdTimer: InterruptableTimer = new InterruptableTimer();
  // private wasHeld = false;
  // private holdCheckTimer;
  // private interactionPoint: mapboxgl.Point;
  private trackMouse = false;
  private infoMode = '';
  public get trackingMouse(): boolean {
    return this.trackMouse;
  }
  // private beforeDigitizing: any = {};
  private tooltip: SpatialTooltip;

  private tooltipOn = false;
  private mouseEvents: any = {
    mouseDown: this._onMouseDown.bind(this),
    keyDown: this._onKeyDown.bind(this),
    mouseMove: this._onMouseMove.bind(this),
    mouseUp: this._onMouseUp.bind(this)
  };

  private interactionModes: MapInteractionModes = {
    info: false,
    querying: false,
    queryingVis: false,
    tooltipping: false,
    hovertipping: false,
    singleSelecting: false,
    singleDeselecting: false,
    roiQuerying: false,
    roiQueryingVis: false,
    roiSelecting: false,
    roiUnselecting: false,
    navigating: false,
    panning: true,
    zooming: true,
    digitizing: false
  };
  private ready = false;
  public get element(): HTMLElement {
    return this.domNode.nativeElement as HTMLElement;
  }
  constructor(
    private mapService: MapService,
    private layersService: LayersApiService,
    private layerService: LayerApiService,
    private toolService: ToolService,
    private modalLocService: ModalLocationEntryService,
    private domNode: ElementRef,
    private dynamicComponentService: DynamicComponentService,
    private actionSvc: ActionHandlerService,
    private buttonGrps: ButtonGroupService,
    private cdr: ChangeDetectorRef,
    private filterService: FeatureFilterService
  ) {
    this.mapBuilt = false;
    (mapboxgl.accessToken as string) = environment.mapbox.accessToken;
  }
  _onKeyDown(e: KeyboardEvent) {
    const target = e.target as HTMLElement;

    if (
     target?.closest(
        'button, input, select, textarea, [contenteditable="true"] , app-button-set,.button-group'
      )
    ) {
      return;
    }
    this._isDown = false;
    if (e.code === 'Escape') {
      this.drawPane.UnsetDrawMode('roi');
      window.document.removeEventListener('mousemove', this.mouseEvents.mouseMove);
      window.document.removeEventListener('keydown', this.mouseEvents.keyDown);
      window.document.removeEventListener('mouseup', this.mouseEvents.mouseUp);

    }
  }
  _isDown: boolean = false;
  _onMouseDown(e: any) {
    this.lastMouseDown = new Date();
    this.downPoint = e.lngLat;
    this._isDown = true;
    if (this.IsInteracting('roiSelecting') || this.IsInteracting('roiUnselecting') || this.IsInteracting('roiQuerying')) {
      if (e.cancelable === true) {
        e.preventDefault();
      }
      return;

      /* this.InitInteraction(e);
      const pt = e.lngLat;
      if (this.trackMouse === false) {
        this.trackMouse = true;
        this.roi.HandlePoint(pt);
      }
      window.document.addEventListener('mousemove', this.mouseEvents.mouseMove, false);
      */
    }


  }

  _onMouseMove(e: MouseEvent) {
    if (!this.trackMouse === true) {
      return;
    }
    if (e.button !== 0) {
      return;
    }

    this.SLMap.moving = true;
  }
  _onMouseUp(e: MouseEvent) {
    this._isDown = false;
    e = e;
    if (!this.trackMouse === true) {
      return;
    }
    this.trackMouse = false;
    if (this.SLMap.moving) {
      this.SLMap.moving = false;
      this.HandleMoveEnd(e);
    }
    window.document.removeEventListener('mousemove', this.mouseEvents.mouseMove);
    window.document.removeEventListener('keydown', this.mouseEvents.keyDown);
    window.document.removeEventListener('mouseup', this.mouseEvents.mouseUp);
    return;
  }



  IsInteracting(mode: string): boolean | null {
    if (!this.interactionModes.hasOwnProperty(mode)) {
      return null;
    }
    let result = this.interactionModes[mode];
    if (!result) return result;
    let isPanning = true;
    switch (mode) {
      case 'digitizing':
        if (this.interactionModes.hasOwnProperty('overrideDigitizing')) {
          const querying = !this.interactionModes.overrideQuerying;
          if (querying !== undefined) {
            result = querying;
          }
        }
        break;
      case 'querying':
        if (this.interactionModes.hasOwnProperty('overrideQuerying')) {
          const querying = !this.interactionModes.overrideQuerying;
          if (querying !== undefined) {
            result = querying;
          }
        }
        break;
      case 'queryingVis':
        if (this.interactionModes.hasOwnProperty('overrideQueryingVis')) {
          const queryingVis = !this.interactionModes.overrideQueryingVis;
          if (queryingVis !== undefined) {
            result = queryingVis;
          }
        }
        break;

      case 'roiQuerying':
        if (this.interactionModes.hasOwnProperty('overrideRoiQuerying')) {
          const roiQuerying = !this.interactionModes.overrideRoiQuerying;
          isPanning = false;
          if (roiQuerying !== undefined) {
            result = roiQuerying;
          }
        }
        break;
      case 'roiQueryingVis':
        if (this.interactionModes.hasOwnProperty('overrideRoiQueryingVis')) {
          const roiQueryingVis = !this.interactionModes.overrideRoiQueryingVis;
          if (roiQueryingVis !== undefined) {
            result = roiQueryingVis;
          }
        }
        break;
      case 'tooltipping':
        if (this.interactionModes.hasOwnProperty('overrideTooltipping')) {
          const toolTipping = !this.interactionModes.overrideTooltipping;
          if (toolTipping !== undefined) {
            result = toolTipping;
          }

        }
        break;
      case 'hovertipping':
        if (this.interactionModes.hasOwnProperty('overrideHoverTipping')) {
          const hoverTipping = !this.interactionModes.overrideHoverTipping;
          if (hoverTipping !== undefined) {
            result = hoverTipping;
          }
        }

        break;
    }
    return result;
  }
  DisableSelecting() {
    this.interactionModes.singleSelecting = false;
    this.interactionModes.singleDeselecting = false;
    this.interactionModes.roiSelecting = false;
    this.interactionModes.roiUnselecting = false;

  }
  ToggleInteraction(mode: string, onOff: boolean = null) {


    if (this.interactionModes[mode] === onOff) return;
    if (onOff && (mode === 'info')) {
      if (mode === 'info') {
        this.DisableSelecting();
        this.drawPane.SetInteractionMode('');
        mode = '';
        this.ClearOverrides();
        this.SetInfoMode(mode);
        mode = this.infoMode;

      }
    }
    if (onOff === null) {
      this.interactionModes[mode] = !this.interactionModes[mode];
      onOff = this.interactionModes[mode];
    }
    switch (onOff) {
      case true:
        this.ToggleInteractionOn(mode);
        this.UpdateDrawPaneDigitizer();

        break;
      case false:
        this.ToggleInteractionOff(mode);
        break;
    }
    this.UpdateInteractions();
  }
  ToggleInteractionOn(mode: string) {
    // if(this.interactionModes[mode] === true) return;

    if (mode !== 'navigating') {
      this.interactionModes.navigating = false;
    }
    this.SetInfoMode(mode);

    if (this.IsInteracting(mode) === null) {
      return;
    }
    const rois = ['roiQuerying', 'roiQueryingVis'];
    const pointers = ['querying', 'queryingVis'];

    if (rois.indexOf(mode) > -1) {
      this.ClearSelModes();
      this.interactionModes.querying = false;
      this.interactionModes.queryingVis = false;
      this.interactionModes.panning = false;
      this.interactionModes.digitizing = false;
      this.digitizerOn = false;
      //this.ToggleInteractionOff('digitizing');

    } else if (pointers.indexOf(mode) > -1) {
      this.ClearSelModes();
      this.interactionModes.roiQuerying = false;
      this.interactionModes.roiQueryingVis = false;
      this.interactionModes.panning = true;
      this.interactionModes.digitizing = false;
      this.digitizerOn = false;

    } else {
      if (mode !== 'panning') {
        this.interactionModes.panning = true;
      }
    }
    if (mode === 'singleSelecting') {
      this.interactionModes.singleDeselecting = false;
      this.interactionModes.roiSelecting = false;
      this.interactionModes.roiUnselecting = false;
      this.interactionModes.overrideQuerying = this.interactionModes.querying;
      this.interactionModes.overrideQueryingVis = this.interactionModes.queryingVis;
      this.interactionModes.overrideRoiQuerying = this.interactionModes.roiQuerying;
      this.interactionModes.overrideRoiQueryingVis = this.interactionModes.roiQueryingVis;
      this.interactionModes.panning = false;
      // this.ToggleInteractionOff('digitizing');

    }
    if (mode === 'singleDeselecting') {
      this.interactionModes.singleSelecting = false;
      this.interactionModes.roiSelecting = false;
      this.interactionModes.roiUnselecting = false;
      this.interactionModes.overrideQuerying = this.interactionModes.querying;
      this.interactionModes.overrideQueryingVis = this.interactionModes.queryingVis;
      this.interactionModes.overrideRoiQuerying = this.interactionModes.roiQuerying;
      this.interactionModes.overrideRoiQueryingVis = this.interactionModes.roiQueryingVis;
      this.interactionModes.panning = false;
      // this.ToggleInteractionOff('digitizing');


    }

    if (mode === 'roiSelecting') {
      this.interactionModes[mode] = true;

      this.interactionModes.singleSelecting = false;
      this.interactionModes.singleDeselecting = false;
      this.interactionModes.roiUnselecting = false;

      this.interactionModes.overrideQuerying = this.interactionModes.querying;
      this.interactionModes.overrideQueryingVis = this.interactionModes.queryingVis;
      this.interactionModes.overrideRoiQuerying = this.interactionModes.roiQuerying;
      this.interactionModes.overrideRoiQueryingVis = this.interactionModes.roiQueryingVis;
      this.interactionModes.panning = false;
      //this.ToggleInteractionOff('digitizing');


    }
    if (mode === 'roiUnselecting') {
      this.interactionModes[mode] = true;

      this.interactionModes.singleSelecting = false;
      this.interactionModes.singleDeselecting = false;
      this.interactionModes.roiSelecting = false;
      this.interactionModes.overrideQuerying = this.interactionModes.querying;
      this.interactionModes.overrideQueryingVis = this.interactionModes.queryingVis;
      this.interactionModes.overrideRoiQuerying = this.interactionModes.roiQuerying;
      this.interactionModes.overrideRoiQueryingVis = this.interactionModes.roiQueryingVis;
      this.interactionModes.panning = false;
      //  this.ToggleInteractionOff('digitizing');


    }
    if (mode === 'navigating') {

      this.interactionModes[mode] = true;
      if (this.interactionModes.singleSelecting) {
        this.ToggleInteractionOff('singleSelecting');
        return;
      }
      if (this.interactionModes.singleDeselecting) {
        this.ToggleInteractionOff('singleDeselecting');
        return;
      }

      if (this.interactionModes.roiSelecting) {
        this.ToggleInteractionOff('roiSelecting');
        return;
      }
      if (this.interactionModes.roiUnselecting) {
        this.ToggleInteractionOff('roiUnselecting');
        return;
      }
      this.interactionModes.overrideQuerying = this.interactionModes.querying;
      this.interactionModes.overrideQueryingVis = this.interactionModes.queryingVis;
      this.interactionModes.overrideRoiQuerying = this.interactionModes.roiQuerying;
      this.interactionModes.overrideRoiQueryingVis = this.interactionModes.roiQueryingVis;

      return;
    }
    if (mode === 'digitizing') {
      this.ClearSelModes();
      this.digitizerOn = true;
      this.OverrideHoverTip(false);
      this.EnableNavigation();
    }
    // Set the current interaction mode value for the
    if (this.interactionModes.hasOwnProperty(mode) === true) {
      this.interactionModes[mode] = true;
    }
    if (!this.digitizerOn) {
      this.DisableDrawing(true);
    }

  }
  ClearSelModes() {
    this.interactionModes.singleSelecting = false;
    this.interactionModes.singleDeselecting = false;
    this.interactionModes.roiSelecting = false;
    this.interactionModes.roiUnselecting = false;
    this.interactionModes.overrideQuerying = false;
    this.interactionModes.overrideQueryingVis = false;
    this.interactionModes.overrideRoiQuerying = false;
    this.interactionModes.overrideRoiQueryingVis = false;
    this.buttonGrps.GetButtonSet('select-tools').ToggleButtons(
      ['select-add', 'unselect', 'roi-sel', 'roi-unsel'],
      false);
    this.buttonGrps.GetButtonSet('select-tools').ToggleButton('info', true);

  }
  ToggleInteractionOff(mode) {
    // if(this.interactionModes[mode] === false) return;
    if (mode === 'digitizing') {
      this.SetInfoMode('');
    }
    if ((mode === 'querying') || (mode === 'tooltipping')) {
      if (mode === 'querying') {
        this.interactionModes.tooltipping = false;
      } else {
        this.interactionModes.querying = false;
      }
      this.SetInfoMode('');
    }
    if (mode === 'queryingVis') {
      this.interactionModes.tooltipping = false;
      this.SetInfoMode('');
    }
    if (this.IsInteracting('querying')
      || this.IsInteracting('queryingVis')
      || this.IsInteracting('tooltipping')
      || this.IsInteracting('navigating')
    ) {
      this.OverrideHoverTip(false);
      this.EnableNavigation();
    }

    if (this.IsInteracting('roiQuerying') || this.IsInteracting('roiQueryingVis')) {
      // this.DisableDrawing();
    }
    if (!!this.interactionModes.hasOwnProperty(mode)) {
      this.interactionModes[mode] = false;
    }
    if (mode === 'digitizing') {
      // this.UpdateDrawPaneROI();
      this.UpdateDrawPaneDigitizer();
    }
  }

  UpdateInteractions() {
    // this.SLMap.src.GetGroup('Info Modes').GetButton('Point query').Toggle(this.interactionModes.pointQuery);
    // this.SLMap.src.GetGroup('Info Modes').GetButton('Region of interest query').Toggle(this.interactionModes.roiQuerying, false);
    this.ToggleButton(this.SLMap.src.GetActionGroup('Info Modes').GetButton('Region of interest query'),
      this.interactionModes.roiQuerying, false);
    this.ToggleButton(this.SLMap.src.GetActionGroup('Info Modes').GetButton('Point query'), this.interactionModes.querying, false);
    this.UpdateStyles();
    this.ResumeTooltipIfReady();
    this.UpdateDragStates();
    // this.UpdateWhenNoInteraction();
    this.UpdateZoomScaleStates();
    this.UpdateButtons();
    this.UpdateDrawPane();
  }
  UpdateStyles() {
    for (const key in this.interactionModes) {
      if (this.interactionModes.hasOwnProperty(key) === true) {
        $(this.domNode.nativeElement).toggleClass('mode-' + key, this.IsInteracting(key));
      }
    }
  }
  ResumeTooltipIfReady() {
    this.UpdateTooltipStatus();
  }
  UpdateDragStates() {
    if (this.interactionModes.panning === false) {
      if (this.map.ui.dragPan.isActive()) {
        this.map.ui.dragPan.disable();
        this.map.ui.dragRotate.disable();
      }
    } else {
      if (!this.map.ui.dragPan.isActive()) {
        this.map.ui.dragPan.enable();
        this.map.ui.dragRotate.enable();
      }
    }
  }
  UpdateWhenNoInteraction() {
    if (!this.IsAnyInteracting()) {
      this.OverrideHoverTip(false);
      this.EnableNavigation();
      this.DisableDrawing();
      this.interactionModes.zooming = true;
      this.interactionModes.panning = true;
    }
  }
  UpdateZoomScaleStates() {
    if (this.interactionModes.zooming === false) {
      this.map.ui.scrollZoom.disable();
      this.map.ui.touchZoomRotate.disable();
      this.map.ui.doubleClickZoom.disable();
      this.map.ui.scrollZoom.disable();
    } else {
      this.map.ui.scrollZoom.enable();
      this.map.ui.touchZoomRotate.enable();
      this.map.ui.doubleClickZoom.enable();
      this.map.ui.scrollZoom.enable();
    }
  }
  UpdateTooltipStatus() {
    if (this.IsInteracting('hovertipping')) {
      this.tooltip.Resume();
      this.tooltipOn = true;
    } else {
      this.tooltip.Stop();
      this.tooltipOn = false;
    }
  }
  UpdateDrawPaneROI() {
    if (
      this.IsInteracting('roiQuerying') ||
      this.IsInteracting('roiQueryingVis')
    ) {
      this.digitizerOn = false;
      this.interactionModes.digitizing = false;
      this.drawPane.drawMode = 'roi';
      this.EnableDrawing();
    } else if (
      this.IsInteracting('roiSelecting') ||
      this.IsInteracting('roiUnselecting')
    ) {
      this.digitizerOn = false;
      this.interactionModes.digitizing = false;
      this.drawPane.drawMode = 'roi-repeating';
      this.SLMap.src.attributeView.vertexTools.Refresh();

      this.drawPane.TurnOn();
    } else if (this.drawPane.drawMode === 'roi-repeating') {
      this.drawPane.drawMode = 'feature';
    }
  }
  UpdateDrawPaneQuery(onOff) {
    if (
      (this.IsInteracting('querying') === true) ||
      (this.IsInteracting('queryingVis') === true) ||
      (this.IsInteracting('singleSelecting') === true) ||
      (this.IsInteracting('singleDeselecting') === true)
    ) {
      // this.interactionModes.digitizing = false;
      // this.DisableDrawing();
    }

  }
  UpdateDrawPaneDigitizer() {
    if (this.interactionModes.digitizing) {
      // this.DisableROI(false);
      // this.EnableDrawing();
      this.drawPane.drawMode = 'feature';
      this.EnableDrawing();
    } else if (this.drawPane.isSnapOn) {
      this.drawPane.drawMode = 'snap';
      this.EnableDrawing();
    } else {
      if (!this.IsOneInteracting(['roiSelecting', 'roiUnselecting'])) {
        if (this.IsInteracting('navigating')) return;
        this.DisableDrawing();
      }
    }

  }
  UpdateDrawPane() {
    this.UpdateDrawPaneROI();
    //this.UpdateDrawPaneQuery();

  }
  UpdateButtons() {
    const group = this.SLMap.src.GetActionGroup('Info Modes');
    const notify = false;
    this.ToggleButton(group.GetButton('Region of interest query'), this.interactionModes.roiQuerying, notify);
    this.ToggleButton(group.GetButton('Point query'), this.interactionModes.querying, notify);
    this.ToggleButton(group.GetButton('Point query (visible layers)'), this.interactionModes.queryingVis, notify);
    this.ToggleButton(group.GetButton('Region of interest query (visible layer)'), this.interactionModes.roiQueryingVis, notify);
  }
  ToggleButton(button: any, state: boolean, notify: boolean) {
    if (!!button) { button.Toggle(state, notify); }
  }
  IsAnyInteracting() {
    const availActions = ['info',
      'querying',
      'queryingVis',
      'singleSelecting',
      'singleDeslecting',
      'roiQuerying',
      'roiQueryingVis',
      'roiSelecting',
      'roiUnselecting',
      'digitizing'];
    let ctr = 0;
    for (const action of availActions) {
      if (this.IsInteracting(action) === true) {
        ctr++;
        break;
      }
    }
    return ctr !== 0;

  }
  IsOneInteracting(actions: Array<string>): boolean {
    let match = false;
    actions.every((action) => {
      if (this.IsInteracting(action)) {
        match = true;
        return false;
      }
      return true;
    });

    return match;
  }

  ToggleInteractionClass(className: string, onOff: boolean = null) {
    if (onOff === null) {
      onOff = !$('.mapboxgl-canvas-container', this.map.ui.getContainer()).hasClass(className);
    }
    $('.mapboxgl-canvas-container', this.map.ui.getContainer()).toggleClass(className, onOff);
  }

  ngOnInit() {
    this.tooltipOn = this.tooltipOn;
    this.style = this.style;
    if (navigator.geolocation) {
      $('body').toggleClass('gps', true);
    }
    this.ready = true;

    this.toolService.SetupButtons(this);

  }
  ngAfterContentInit() {



  }
  private lastMove: number = Number(new Date());

  private buildMapParams
  BuildMap(map: SLMap, toolSet: ToolSetComponent, readyHandler: DictHandler, optExtent: mapboxgl.LngLatBounds = null): void {

    this.map = map;
    this.map.sequencer = new MapTaskSequencer(this);
    if (!this.ready) {
      setTimeout(() => {
        this.BuildMap(map, toolSet, readyHandler, optExtent);

      });
      return;
    }
    this.SLMap.digitizer.onStateChange.subscribe((state) => {
      if (this.interactionModes.digitizing === state) return;
      this.ToggleInteraction('digitizing', state);
      this.SLMap.DigitizerUpdated();
    });
    this.tooltip = new SpatialTooltip(this.map);
    if (optExtent === null) {
      optExtent = this.map.GetLayerBounds();
    }
    this.map.SetInteractionModes(this.interactionModes);
    this.map.SetComponent(this);
    this.toolSet = toolSet;

    this.mapContainer.nativeElement.style.width = this.domNode.nativeElement.parentElement.offsetWidth + 'px !important';
    this.mapContainer.nativeElement.style.height = this.domNode.nativeElement.parentElement.offsetHeight + 'px !important';

    this.drawPane.width = this.mapContainer.nativeElement.style.width;
    this.drawPane.height = this.mapContainer.nativeElement.style.height;

    const mapUI: mapboxgl.Map = new mapboxgl.Map({
      dragPan: {
        maxSpeed: 0
      },
      container: this.mapContainer.nativeElement,
      style: 'mapbox://styles/simplelayers-dev/cjyxwsuje3b761cp740vhk1by',
      zoom: 2,
      center: optExtent.getCenter(),
      preserveDrawingBuffer: true,
      optimizeForTerrain: false,
      optimize: false
    });


    this.mapContainer.nativeElement.style.width = this.domNode.nativeElement.parentElement.offsetWidth + 'px !important';
    this.mapContainer.nativeElement.style.height = this.domNode.nativeElement.parentElement.offsetHeight + 'px !important';
    setTimeout(() => { this.UpdateSize(); }, 120);


    // mapUI.fitBounds(optExtent, { animate: false }, NavEvents.New('map-component/set-initial-bounds'));

    this.map.SetUI(mapUI, readyHandler);
    /*if (!this.initPosition) {
      this.initPosition = this.map.viewPosition;
      this.initPosition.bounds = this.map.GetLayerBounds();
    }*/
    /*
    const scale = new mapboxgl.ScaleControl({
      maxWidth: this.SLMap.inch,
      unit: 'imperial'
    });
    mapUI.addControl(scale);
    scale.setUnit('imperial');
    scale.setUnit('')
    */
    // const md = new MobileDetect(window.navigator.userAgent);
    mapUI.on('dblclick', (event) => {
      if (this.drawPane.interactionMode !== '') {
        event.preventDefault();
      }
    })
    mapUI.on('click', (event) => {
      this.MapClick(event, true);
    });
    mapUI.on('mousedown', this.mouseEvents.mouseDown);
    mapUI.on('mouseup', this.mouseEvents.mouseUp);

    mapUI.on('load', () => {



      for (const layer of map.layers) {
        layer.Render(map);
      }
      mapUI.addSource('mapbox-dem', {
        'type': 'raster-dem',
        'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
        'tileSize': 512,
        'maxzoom': 14
      });
      mapUI.setTerrain({ source: 'mapbox-dem', exaggeration: 1.5 });

      /*mapUI.addSource('mapbox-dem', {
        type: 'raster-dem',
        url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
        tileSize: 512,
        maxzoom: 14
      });*/
      // add the DEM source as a terrain layer with exaggerated height

      mapUI.addLayer({
        id: 'sky',
        type: 'sky',
        paint: {
          'sky-type': 'gradient',
          'sky-atmosphere-sun': [0.0, 0.0],
          'sky-atmosphere-sun-intensity': 15
        }
      });
      this.mapBuilt = true;
      $('.mapboxgl-ctrl-scale').remove().appendTo($('.footer span.scale', this.SLMap.src.domNode.nativeElement));
      this.SLMap.src.UpdateLoc(this.SLMap.ui.getCenter());
      $(this.drawPane.domElement).insertAfter($('.mapboxgl-canvas')[0]);
      const emptyAttrib = document.getElementsByClassName('mapboxgl-attrib-empty');
      if (emptyAttrib.length > 0) {
        emptyAttrib[0].classList.toggle('mapboxgl-attrib-empty');
      }

    });

    mapUI.on('move', (event: any) => {
      if (!this.SLMap.moving) {
        this.SLMap.moving = true;
        this._lastMove = Number(new Date());
      }
      this.HandleMove(event);
    });
    mapUI.on('moveend', (ev: any) => {
      this.HandleMoveEnd(ev);

    });

    mapUI.on('pitchend', () => {
      NavigationAction.UpdateIsNorth(this);
      DisplayAction.ToggleTerrain(this, { isOn: (this.SLMap.ui.getPitch() > 0) })
    })
    mapUI.on('rotate', (ev: any) => {
      ev = ev;
      this.toolService.DoAction('navigation/bearing-update', this);
      this.drawPane.UpdateAll();
      NavigationAction.UpdateIsNorth(this);
    });
    mapUI.on('rotateend', (ev: any) => {
      ev = ev;
      this.toolService.DoAction('navigation/bearing-update', this);
      this.drawPane.UpdateAll();
      NavigationAction.UpdateIsNorth(this);
    });
    this.toolSet.actions.subscribe((data: any) => {
      this.HandleToolAction(data);
    });


    this.UpdateSize();
    this.spatialContext = new PixoSpatial();
    this.tooltip.SetMap(this.spatialContext, mapUI);
    this.tooltip.SetFilterService(this.filterService);
    this.drawPane.SetSpatialContext(this.spatialContext);
    this.spatialContext.Attach(
      (spatialCoord: SpatialCoord): PixoPt => {
        const pt: mapboxgl.Point = this.map.ui.project(spatialCoord);
        return this.spatialContext.PixoPt(pt);
      },
      (pixoPt: PixoPt) => {
        const pt: mapboxgl.Point = new mapboxgl.Point(pixoPt.x, pixoPt.y);
        const startPosition: MapPosition = this.map.viewPosition;
        this.map.SetViewPosition({
          location: {
            center: this.map.GetCenter(),
            zoom: startPosition.location.zoom,
            bearing: 0,
            pitch: 0,
          },
          width: startPosition.width,
          height: startPosition.height


        }, NavEvents.NewInternal('viewstate/set-un-oriented'));
        this.map.ui.setBearing(0, { internal: true });
        this.map.ui.setPitch(0, { internal: true });
        const lngLat: mapboxgl.LngLat = this.map.ui.unproject(pt);
        this.map.SetViewPosition(startPosition, NavEvents.NewInternal('viewstate/set-oriented'));
        return this.spatialContext.SpatialCoord(lngLat);

      }
    );

    this.PUCMan = new PUCManager(this.map);
    const emptyAttrib = document.getElementsByClassName('mapboxgl-attrib-empty');
    if (emptyAttrib.length > 0) {
      emptyAttrib[0].classList.toggle('mapboxgl-attrib-empty');
    }
  }
  _lastMove = Number(new Date());
  HandleMove(ev: any) {
    //this.touched = true;
    //this._rendering = '1';
    //setTimeout(() => {
    //  this.Render(map, force);
    //}, 50);

    if (!!ev.preventDefault) {
      ev.preventDefault();
    }
    if ((ev.internal === true) || !this.mapBuilt || !ev) {
      return;
    }
    const wasMoving = this.map.moving;
    this.map.moving = true;
    if (!wasMoving) {
      this.tooltip?.OnMapMoveStart();
    }
    const now = Number(new Date());
    if ((now - this._lastMove) > 2500) {
      if (this.map.moving) {
        this.SLMap.src.UpdateLoc(this.SLMap.ui.getCenter());
      };
    }
    // this.SLMap.src.UpdateLoc(this.SLMap.ui.getCenter());
    this.drawPane.UpdateAll();
  }
  HandleMoveEnd(ev: any) {
    const wasMoving = this.map.moving;
    this.map.moving = this._isDown;
    if (!!ev.preventDefault) {
      ev.preventDefault();
    }
    if (!this.mapBuilt) {
      return;
    }

    if (ev.internal === true) {
      return;
    }
    if (wasMoving && !this.map.moving) {
      this.tooltip?.OnMapMoveEnd();
    }

    this.SLMap.src.UpdateLoc(this.SLMap.ui.getCenter());
    this.drawPane.UpdateAll();
  }
  ClearOverrides() {
    const overrideModes = ['overrideDigitizing', 'overrideQuerying', 'overrideQueryingVis', 'overrideRoiQuerying', 'overrideRoiQueryingVis', 'overrideNavigating', 'overrideTooltipping'];
    for (const override of overrideModes) {
      delete this.interactionModes[override];
    }


  }
  UpdateInitPosition(optBounds = null) {

    this.initPosition = this.map.viewPosition;
    this.initPosition.bounds = (optBounds !== null) ? optBounds : this.map.GetLayerBounds();
    this.map.history.Init();

  }
  InitInteraction(event: any, simulated = false) {

    if (this.map.moving === true) return;

    // this.interactionPoint = event.point;
    // this.wasHeld = false;


    if (!simulated) {
      if (((event.lngLat.lng !== this.downPoint.lng) || (event.lngLat.lat !== this.downPoint.lat))) {
        return;
      }
    }
    // this.interactionPoint = event.point;
    if (this.IsOneInteracting(['roiQuerying', 'roiQueryingVis', 'querying', 'queryingVis'])) {
      this.SetMarker(event);
    }
    let notify = this.interactionModes.singleSelecting === true;
    notify = notify || this.interactionModes.singleDeselecting === true;

    if (notify === true) {
      this.interactions.emit({ modes: this.interactionModes, point: event.point, lngLat: event.lngLat });
    }
    this.interactionsChanges.emit(this.interactionModes);


    /*this.holdCheckTimer = setTimeout(() => {
      if (this.isHolding !== false) {
        this.Holding(event);
      }
    }, 500);*/
  }
  DumpInfo(ev: any) {
    // console.log(ev);
    // console.log(this.map.ui.getBounds());
    // console.log(this.map.ui.getCanvas().width, this.map.ui.getCanvas().height);
  }
  SetSize(width: number, height: number) {
    height = height;
    width = width;
    this.UpdateSize();
  }
  UpdateSize() {
    const varWidth = 'var(--fw)'; // this.domNode.nativeElement.parentElement.offsetWidth + 'px !important';
    // const styleHeight = 'var(--fh)';// this.domNode.nativeElement.parentElement.offsetHeight + 'px !important';
    this.offsetTop = (document.getElementsByTagName('app-map')[0] as HTMLDivElement).offsetTop;
    this.offsetLeft = (document.getElementsByTagName('app-map')[0] as HTMLDivElement).offsetLeft;

    this.mapContainer.nativeElement.style.width = varWidth;
    // this.mapContainer.nativeElement.style.height = styleHeight;
    const styleHeight = (this.mapContainer.nativeElement as HTMLDivElement).clientHeight;
    const styleWidth = (this.mapContainer.nativeElement as HTMLDivElement).clientWidth;
    if (this.SLMap && this.SLMap.ui) {
      this.SLMap.ui.resize();
    }
    this.toolService.DoAction('navigation/bearing-update', this);
    this.drawPane.UpdateSize(
      styleWidth,
      styleHeight);

  }

  ngOnDestroy() {
    this.mapService.RemoveMap(this.map);
  }

  HandleToolAction(data: any) {

    if (data.action === undefined) {
      return;
    }
    //ToDo: Test Multi Actions
    const actions = data.action.split(';')
    data.subactions = {}
    if (actions.length > 1) {
      for (const action of actions) {
        const subParamsSrc: Array<string> = action.split(':')
        const subAction: string = subParamsSrc.shift()
        const subData = { action: subAction }
        for (const subParam of subParamsSrc) {
          const keyVal = subParam.split('=')
          if (keyVal.length == 2) {
            subData[keyVal[0]] = keyVal[1]
          }
        }
        this.HandleToolAction(subData)
      }
      return;
    }
    switch (data.action) {
      case 'tools/editor':
        EditorAction.ShowEditor(this, {});
        break;
      case 'info/memory-restore':
        data.featureLayer = this.map.memory.layer.id;
        data.gids = this.map.memory.features;
        data.action = 'info/query-by-feature';
        data.layers = [this.map.memory.layer];
        data.context = 'memory-restore';
        data.exact = true;
        break;
      case 'info/memory-query':
        data.featureLayer = this.map.memory.layer.id;
        data.gids = this.map.memory.features;
        data.action = 'info/query-by-feature';
        data.context = 'memory-query';
        break;
      case 'info/memory-query-vis':
        data.featureLayer = this.map.memory.layer.id;
        data.gids = this.map.memory.features;
        data.action = 'info/query-by-feature';
        data.visOnly = true;
        data.cpntext = 'memory-query-vis';
        break;
    }
    if (data.action.split('/').shift() === 'tools') {
      if (data.action === 'tools/editor') {

        // this.ToggleInteraction('digitizing', true);
        // return;
      } else {
        /*if (this.interactionModes.digitizing === true) {
          this.ToggleInteraction('digitizing', false);
        }
        */
      }

    }
    this.toolService.DoAction(data.action, this, data);

  }
  Holding(event: any) {

    this.isHolding = true;
    // this.wasHeld = false;
    if (this.map.component.IsInteracting('tooltipping') === false) {
      this.isHolding = false;
      return;
    }
    // this.map.component.ToggleInteraction('tooltipping', false);
    if (this.infoElement) {

    } else {
      this.SetMarker(event);
    }

  }
  StopHolding(event: any) {
    event = event;
    if (!this.isHolding) {
      return;
    }
    // clearTimeout(this.holdCheckTimer);

    this.isHolding = false;
    this.holdTimer.Stop();
    this.HandleToolAction({ action: 'info/hold-stop', marker: this.infoElement });

    /* if (this.infoMarker.getPopup()) {
      if (!this.infoMarker.getPopup().isOpen()) {
        this.infoMarker.togglePopup();
      }
    } */


  }
  SetMarker(event: any) {



    this.PUCMan.SetPoint(event.lngLat);
    // this.HandleToolAction({ action: 'info/hold-stop', marker: this.infoElement });
  }
  InfoClick(event: any, simulated = false) {
    if (this.map.moving === true) return;
    if (!(this.IsInteracting('querying') || this.IsInteracting('queryingVis'))) {

      if (!(!!event.queryVis)) {
        return;
      }
    }
    if (!simulated) {

      if (((event.lngLat.lng !== this.downPoint.lng) || (event.lngLat.lat !== this.downPoint.lat))) {
        return;
      }
    }
    // this.StopHolding(event);
    this.map.ClearResult();
    const params: any = { mapPoint: event.lngLat };
    params.visOnly = (this.IsInteracting('queryingVis')) === true;
    if (!!event.queryVis) {
      if (event.queryVis === true) {
        params.visOnly = true;
      }
    }
    // this.StopHolding(event);
    this.toolService.DoAction('info/query', this, params);
  }
  InfoMarkerClick(event: any) {
    event = event;
    /* if (event.cancelable === true) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    this.infoMarker.remove();
    delete this.infoMarker;
    if (this.map.hasResults === true) {
      return;
    }
    this.map.ClearResult();
    */
  }

  GetViewArea() {
    const rect = this.domNode.nativeElement.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY,
      right: rect.left + window.scrollX + rect.width,
      bottom: rect.top + window.scrollY + rect.height
    };
  }
  IsClientPointWithin(pt: any): boolean {
    const viewArea = this.GetViewArea();
    return (
      (pt.x >= viewArea.left) &&
      (pt.x <= viewArea.right) &&
      (pt.y >= viewArea.top) &&
      (pt.y <= viewArea.bottom)
    );

  }
  HandleROIQuery(roi: any) {
    roi = roi;
    // do something cool.
  }
  lastMouseDown: Date = new Date();
  downPoint: any;







  MapClick(event: any, simulated: boolean = false) {
    const wasHoverTipping = this.interactionModes.hovertipping;

    if (this.IsInteracting('querying') || this.IsInteracting('queryingVis') || this.IsInteracting('roiQuerying') || this.IsInteracting('roiQueryingVis')) {
      if (this.map.src.IsSuppressed('query')) {
        this.QueryModeNone();
        this.SetInteraction('hovertipping', wasHoverTipping);
        this.UpdateInteractions();
        return;
      }
    }


    if (this.interactionModes.singleSelecting === true) {
      this.InitInteraction(event, simulated);
    }
    if (this.interactionModes.singleDeselecting === true) {
      this.InitInteraction(event, simulated);
    }
    if (!(this.IsInteracting('tooltipping') || this.IsInteracting('querying') || this.IsInteracting('queryingVis'))) {
      if (this.SLMap.src.IsSuppressed('query')) {
        return;
      }
      if (simulated !== true) {
        return;
      }
    }
    this.InitInteraction(event, simulated);
    this.InfoClick(event, simulated);
  }
  HandleDigitizerPowerChange(isOn: boolean) {

    this.digitizerOnChange.emit(isOn);
  }
  SetDigitizerLayer(layer: SLLayer) {
    this.drawPane.SetLayer(layer);
  }
  EnableNavigation() {
    this.interactionModes.panning = true;
    this.interactionModes.zooming = true;


    this.SLMap.ui.dragPan.enable();

  }
  DisableNavigation() {
    this.interactionModes.panning = false;
    this.interactionModes.zooming = false;

    this.SLMap.ui.dragPan.disable();

  }
  EnableDrawing() {
    if (this.SLMap && this.SLMap.digitizer && (this.interactionModes.digitizing)) {
      this.SLMap.digitizer.TurnOn();
      this.drawPane.drawMode = 'feature';
      this.SLMap.src.attributeView.vertexTools.Refresh();
    }
    this.drawPane.TurnOn();
  }
  DisableDrawing(hide: boolean = true) {
    if (this.SLMap && this.SLMap.digitizer) {
      this.drawPane.drawMode = '';
      this.SLMap.digitizer.TurnOff(hide);
      this.drawPane.TurnOff(hide);
      this.SLMap.src.attributeView.vertexTools.Refresh();
    }
  }

  OverrideHoverTip(override: boolean) {
    if (override === true) {
      this.interactionModes.overrideHoverTipping = true;
    } else {
      if (!!this.interactionModes.overrideHoverTipping) {
        delete this.interactionModes.overrideHoverTipping;
      }
    }
  }
  QueryModeNone() {
    if (this.IsOneInteracting(['roiSelecting', 'roiUnselecting'])) {
      return;
    }

    this.interactionModes.roiQuerying = false;
    this.interactionModes.roiQueryingVis = false;
    this.interactionModes.querying = false;
    this.interactionModes.queryingVis = false;
    this.UpdateInteractions();
    // map.ToggleInteraction('roiQuerying', false);
    // map.ToggleInteraction('roiQueryingVis', false);
    // map.ToggleInteraction('querying', false);
    // map.ToggleInteraction('queryingVis', false);
  }
  public defaultInfoMode = 'querying';
  SetInfoMode(mode: string): boolean {
    if (mode === 'navigating') {
      if (this.interactionModes.digitizing === true) {
        return false;
      }
    }
    const infoModes = ['digitizing', 'querying', 'queryingVis', 'roiQuerying', 'roiQueryingVis', 'navigating'];
    const overrideModes = ['overrideDigitizing', 'overrideQuerying', 'overridingQueryingVis', 'overrideRoiQuerying', 'overrideRoiQueryingVis', 'overrideNavigating'];

    if (mode === '') {
      if (!!this.interactionModes[this.defaultInfoMode]) {
        return this.SetInfoMode(this.defaultInfoMode);
      }
    }
    let index = 0;
    for (let i = 0, l = infoModes.length; i < l; i++) {
      if (mode === infoModes[i]) {
        this.infoMode = infoModes[i];
        index = i;
        break;
      }
    }

    return (mode !== '') && (index !== -1);
  }
  SetInteraction(which: string, value: boolean) {
    this.interactionModes[which] = value;
  }
  SetScale(screenInchDistMeters: number) {
    const mapWidth = (this.SLMap.ui.getCanvas() as HTMLCanvasElement).width;
    const mapHeight = (this.SLMap.ui.getCanvas() as HTMLCanvasElement).height;
    const center = this.SLMap.ui.getCenter();
    const currentMPerIn = Math.round(this.SLMap.GetMapScale('meters-m').length);
    const targetMPerIn = Math.round(Number(screenInchDistMeters));
    const widthIn = mapWidth / this.SLMap.inch;
    const currentWidthM = widthIn * currentMPerIn;
    const offset = (3 / this.SLMap.inch) * currentMPerIn;
    // targetPerCurrent is a ratio of target meters per current meters
    const targetMPerCurrentM = targetMPerIn / currentMPerIn;
    const targetWidthM = currentWidthM * targetMPerCurrentM;
    // because targetPerCurrent has current in the denominator multiplying by current width
    // will cancel out current and leave us with a target meter width.
    const turfCenter = point([center.lng, center.lat])
    const east = destination(turfCenter, ((targetWidthM - offset) / 2) / 1000, +90, { units: 'kilometers' });
    const west = destination(turfCenter, ((targetWidthM - offset) / 2) / 1000, -90, { units: 'kilometers' });
    this.SLMap.ui.fitBounds([{
      lng: west.geometry.coordinates[0], lat: west.geometry.coordinates[1]
    }, {
      lng: east.geometry.coordinates[0], lat: east.geometry.coordinates[1]
    }], {
      duration: 0,
      linear: false,
      padding: 0,
      maxZoom: 1000
    });
  }
  ToggleReticle(isOn?: boolean) {
    if (isOn === undefined) isOn = !this.reticleEnabled;
    this.reticleEnabled = isOn;
    this.printReticle.nativeElement.classList.toggle('hidden', !this.reticleEnabled);
  }
  ToggleReticleExtra(isOn?: boolean) {
    if (isOn === undefined) {
      isOn = !this.printReticle.nativeElement.classList.contains('has-extra')
    }
    this.printReticle.nativeElement.classList.toggle('has-extra', isOn);
  }
  HandleROI(roi: ROICorners): string {
    if (this.IsInteracting('roiQuerying') === true) {
      this.HandleToolAction({
        action: 'info/roi-query',
        result: roi,
        layers: this.map.layerListService.GetSearchableLayers(this.map.layers),
        visOnly: false
      });
      return '';
    } else if (this.IsInteracting('roiQueryingVis') === true) {
      this.HandleToolAction({
        action: 'info/roi-query',
        result: roi,
        layers: this.map.layerListService.GetSearchableLayers(this.map.layers),
        visOnly: true
      });
      return '';
    } else {
      if (this.IsInteracting('roiSelecting') === true) {
        this.HandleToolAction({
          action: 'info/roi-sel',
          result: roi
        });
        return 'rectangle';
      }
      if (this.IsInteracting('roiUnselecting') === true) {
        this.HandleToolAction({
          action: 'info/roi-desel',
          result: roi
        });
        return 'rectangle';
      }
    }
    return '';

  }
  SetFocus() {
    const params = {focusVisible:true}
    this.mapContainer.nativeElement.focus(params);
  }
}
